import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';

import { AppMaterialComponentsModule } from '../../app-material-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegistrationComponent } from './components/registration/components/registration/registration.component';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppLoadService } from '@ebb-v2/ebb-integration';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
@NgModule({
  declarations: [RegistrationComponent],
  imports: [
    CommonModule,
    AppMaterialComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective, NgxMaskPipe,
    RecaptchaModule,
    RecaptchaFormsModule,
    RouterModule.forChild([
      {
        path: '',
        redirectTo: 'register',
        pathMatch: 'full'
      },
      {
        path: 'register',
        component: RegistrationComponent
      }
    ])
  ],
  providers:[provideNgxMask(),  {
    provide: RECAPTCHA_SETTINGS,
    useFactory: (appLoadService: AppLoadService): RecaptchaSettings => ({
      siteKey: appLoadService.getRecaptchaKey()
    }),
    deps: [AppLoadService]
  },],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [RegistrationModule]
})
export class RegistrationModule {}
